import { IconButton, Menu, MenuItem } from "@mui/material";
import type { JSX, MouseEvent } from "react";
import { useState } from "react";

import { GlobeIcon } from "@/assets";

export type Language = "en" | "de";

interface LanguageSwitcherProps {
  language: Language;
  setLanguage: (lang: Language) => void;
}

const LanguageSwitcher = ({ language, setLanguage }: LanguageSwitcherProps): JSX.Element => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleOpen = (event: MouseEvent<HTMLButtonElement>): void => setAnchorEl(event.currentTarget);
  const handleClose = (): void => setAnchorEl(null);

  const handleChange = (lang: Language): void => {
    setLanguage(lang);
    handleClose();
  };

  return (
    <>
      <IconButton onClick={handleOpen}>
        <GlobeIcon color="primary" />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem onClick={() => handleChange("de")} selected={language == "de"}>
          Deutsch
        </MenuItem>
        <MenuItem onClick={() => handleChange("en")} selected={language == "en"} disabled>
          English
        </MenuItem>
      </Menu>
    </>
  );
};

export default LanguageSwitcher;
